<template>
  <v-card>
    <v-card-text>
      <v-row class="bm-0 mb-0 pb-0">
        <v-col cols="12">
          <v-card-subtitle class="ml-2">
            <h2 class="text-uppercase indigo--text">
              {{ currentUser.nombre }} {{ currentUser.primer_apellido }} {{ currentUser.segundo_apellido }}
            </h2>
            <h4 class="text-uppercase" style="color: #616161">
              {{ currentUser.roles[0].descripcion }}
            </h4>
            <v-divider class="mt-1"/>
          </v-card-subtitle>
        </v-col>
      </v-row>
      <v-toolbar color="#1D2E4B" dark dense>
        <v-toolbar-title class="text-uppercase"><b>Previsualización de tocas</b>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
          v-if="roleUser == 'secacu' || roleUser == 'superadmin'"
          small
          class="white--text mt-1"
          color="grey darken-2"
          @click="dialog = true"
        >Nueva previsualización
        </v-btn>
      </v-toolbar>
      
      <v-container fluid>
        <v-form ref="preview" @submit.prevent="getPrevisualizaciones" v-model="validPreview">
          <v-row justify="center">
            <!-- <v-col cols="6"></v-col> -->
            <v-col cols="3" v-if="roleUser == 'magistrado'">
              <v-select
                :items="listStatus"
                v-model="statusToca"
                label="Seleccione status"
                item-value="status"
                item-text="text"
                @change="getPrevisualizaciones()"
              >
              </v-select>
            </v-col>
            <v-col cols="3">
              <v-text-field
                placeholder="Ingrese número de Toca"
                v-model="buscar_previsualizacion"
                hint="Ej. 1/2024"
                :loading="loading"
                :rules="[rules.tocaRules]"
                v-on:keyup.enter="getPrevisualizaciones"
                @input="(val) => (buscar_previsualizacion = buscar_previsualizacion.toUpperCase())"
              >
                <!-- @keyup="buttons_on_alert = false, btn_JO = false, btn_JT = false" -->
              </v-text-field>
            </v-col>
            <v-col cols="2">
              <v-btn
                small
                class="white--text mt-5"
                :loading="loading"
                @click="getPrevisualizaciones()"
                color="#286090"
                :disabled="!validPreview"
              ><v-icon small class="mr-2">mdi-magnify</v-icon>Buscar
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
        
        <v-data-table
          actions
          light
          dense
          :headers="headers"
          :items="listPrevisualizaciones"
          :loading="loading"
          :items-per-page="itemsPerPage"
          :server-items-length="totalItems"
          loading-text="Cargando... Por favor espere"
          no-data-text="No hay registros por mostrar"
          hide-default-footer
        >
          <template v-slot:[`item.toca`]="{ item }">
            <span v-if="!item.toca.complemento">
              {{ item.apelacion.toca.numero }}/{{ item.apelacion.toca.anio }}
            </span>
            <span v-else>
              {{ item.apelacion.toca.numero }}/{{ item.apelacion.toca.anio }}-{{ item.apelacion.toca.complemento }}
            </span>
          </template>
          <template v-slot:[`item.created_at`]="{ item }">
            <span>{{ item.created_at | formatDate }}</span>
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-btn
              x-small
              class="white--text btn-spacing"
              color="#607D8B"
              @click="showApelacionElectronica(item)"
            >
            <v-icon small class="mr-2">mdi-eye</v-icon>
              Ver apelación Electrónica
            </v-btn>
            &nbsp;
            <v-btn
              v-if="(roleUser == 'secacu' || roleUser == 'superadmin')"
              x-small
              class="white--text btn-spacing"
              color="cyan darken-2"
              @click="editItem(item)"
            >
            <v-icon small class="mr-1">mdi-pencil</v-icon>
              Editar Ponencia
            </v-btn>
            &nbsp;
            <v-btn
              v-if="(roleUser == 'magistrado') && (!item.relator_id)"
              x-small
              class="white--text btn-spacing"
              color="green"
              @click="showDialogRelator(item)"
            >
            <v-icon small class="mr-2">mdi-file-document-arrow-right-outline</v-icon>
              Asignar relator
            </v-btn>
            <v-btn
              v-else-if="(roleUser == 'magistrado' || roleUser == 'superadmin') && (item.relator_id)"
              x-small
              class="white--text btn-spacing"
              color="cyan darken-2"
              @click="showDialogRelator(item)"
            >
            <v-icon small class="mr-1">mdi-pencil</v-icon>
              Editar Relator
            </v-btn>
          </template>
        </v-data-table>
        <div class="text-center pt-2">
            <v-pagination
              v-if="pagination.total > 1"
              v-model="pagination.current"
              :length="pagination.total"
              :total-visible="7"
              @input="onPageChange"
              color="#1D2E4B"
            ></v-pagination>
          </div>
      </v-container>
    </v-card-text>

    <!-- DIALOG PREVISUALIZACIÓN -->
    <v-dialog
      v-model="dialog"
      max-width="900px"
      persistent
    >
      <v-card elevation="0">
        <v-toolbar
          color="#286090"
          dark
          class="text-uppercase"
        >
          <img src="@/assets/logo_nuevo.png"style="width:50px;height:51px" class="mr-4">
          <h2>{{formTitle}}
          </h2>
        </v-toolbar>

        <v-container grid-list-md>
          <v-card-text>
            <v-form v-if="editedIndex === -1" ref="search" @submit.prevent="searchToca" v-model="validSearch">
              <v-row justify="center">
                <v-col cols="12" md="3">
                  <h2 
                    class="mt-3 ml-7"
                    style="color:#AF8936"
                  >BUSCAR TOCA:
                </h2>
                </v-col>
                <v-col cols="6" class="pt-0">
                  <v-text-field
                    placeholder="Ingrese número de Toca"
                    v-model="buscar"
                    hint="Ej. 1/2024"
                    :loading="loading"
                    :rules="[rules.tocaRules]"
                    v-on:keyup.enter="searchToca"
                    @keyup="buttons_on_alert = false"
                    @input="(val) => (buscar = buscar.toUpperCase())"
                  >
                    <!-- @keyup="buttons_on_alert = false, btn_JO = false, btn_JT = false" -->
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="3">
                  <v-btn
                    class="white--text"
                    :loading="loading"
                    @click="searchToca()"
                    color="#286090"
                    :disabled="!validSearch"
                  ><v-icon small class="mr-2">mdi-magnify</v-icon>Buscar
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>

            <v-card v-if="listTocas && listTocas.length" v-for="(toca, i) in listTocas" :key="'toca_'+i">
              <v-toolbar-title style="background-color: #9c6f05;height: 45px;">
                <div class="text-center mb-1" style="color: white;margin-top: 8px;">
                  <b>Toca: {{ toca.numero }}/{{ toca.anio }}
                    <span v-if="toca.complemento">-{{ toca.complemento}}</span>
                    ({{ toca.tipo_juicio == 'JO' ? 'Juicio Oral' : 'Jucio Tradicional' }})
                  </b>
                  <v-btn
                    v-if="roleUser == 'superadmin' "
                    style="float: right;"
                    icon
                    class="mt-n1 mr-2 ml-n11"
                    color="white"
                    @click="tipo_juicio = toca.tipo_juicio, editToca(toca)"
                  >
                    <v-icon>
                      mdi-pencil
                    </v-icon>
                  </v-btn>
                </div>
              </v-toolbar-title>
              <v-list v-if="listTocas">
                <span v-for="(apelacion, i) in toca.apelaciones"
                  :key="apelacion.id">
                      <div align="center">
                        <b>FECHA DE RECEPCIÓN - <span>{{apelacion.fecha_recepcion | formatDate}}</span></b>
                      </div>
                      <v-spacer></v-spacer>
                  <v-divider></v-divider>
                </span>
              </v-list>

              <div v-if="relator_asignado" align="center">
                <v-col cols="12" md="8">
                  <v-alert
                  border="left"
                  color="#9c6f05"
                  type="info"
                  dense
                  outlined
                  elevation="2"
                >¡La previsualización del toca ya fue asignada a un relator!</v-alert>
                </v-col>
              </div>
              
              <div align="center">
                <v-col cols="12" md="6">
                  <v-autocomplete
                    outlined
                    label="Seleccione una ponencia"
                    :item-text=" item => item.magistrado"
                    item-value="id"
                    return-object
                    persistent-hint
                    :items = "getAllPonencias"
                    v-model="ponencia_selected"
                    :rules="[v => !!v || 'Campo requerido']"
                    required
                  />
                </v-col>
              </div>
              <v-spacer></v-spacer>
              <v-divider class="mt-2 mb-3"></v-divider> 
            </v-card>

            <v-form ref="form" v-model="valid" lazy-validation>
              <div v-if="resultSearch === false">
                <v-alert
                  prominent
                  outlined
                  type="error"
                >
                  <v-row align="center">
                    <v-col class="grow hidden-xs-only">No se encontro ningún registro relacionado con la búsqueda.</v-col>
                  </v-row>
                </v-alert>
              </div>

              <v-divider></v-divider>
              <v-card-actions class="mb-3">
                <v-spacer></v-spacer>
                <v-btn
                  class="mb-3 mt-2"
                  color="grey darken-1"
                  text
                  :loading="loading"
                  @click.native="close">Cancelar
                </v-btn>
                <v-btn 
                  v-if="editedIndex > -1"
                  class=""
                  color="#607D8B" 
                  text
                  :loading="loading" 
                  :disabled="!valid || (!listTocas.length)"
                  @click.native="editar()"
                >
                  Actualizar Previsualización
                </v-btn>
                <v-btn
                  v-else-if="editedIndex === -1 && listTocas && listTocas.length > 0"
                  class="mb-3 mt-2"
                  color="#607D8B"
                  text
                  :loading="loading"
                  :disabled="!valid || (!listTocas.length)"
                  @click="validate()"
                >
                  Asignar Previsualización
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-card-text>
          <!-- </v-card> -->
              
          <!-- </v-card-text> -->
        </v-container>
      </v-card>
    </v-dialog>
    <!-- FIN DIALOG AGREGAR AUTORIZACIÓN -->

    <!-- DIALOG ASINAR RELATOR -->
    <v-dialog v-if="dialogRelator"
      persistent 
      max-width="600px"
      v-model="dialogRelator" 
    >
        <v-toolbar color="#1D2E4B" dark dense>
          <img src="@/assets/logo_nuevo.png"style="width:40px;height:41px" class="mr-4">
            <v-toolbar-title class="text-uppercase"><b>{{ formTitleRelator }}</b>
            </v-toolbar-title>
            <v-spacer></v-spacer>
        <v-btn color="#1D2E4B" dark @click.native="closeDialogRelator">cerrar</v-btn>
        </v-toolbar>
        <v-card>
          <v-container>
            <v-form ref="relator" v-model="validRelator">
              <v-row>
              <v-col cols="12">
                <h2 class="mb-2">TOCA:
                    {{ num_toca }}
                </h2>
              </v-col>
            </v-row>
            <v-autocomplete
              class="mt-4"
              outlined
              label="Seleccione un relator"
              :item-text="item =>
                item.nombre + ' ' +
                item.primer_apellido + ' ' +
                (item.segundo_apellido ? item.segundo_apellido : '')
              "
              item-value="id"
              persistent-hint
              return-object
              :items = "listRelatoresPonencia"
              v-model="relator_selected"
              :rules="[v => !!v || 'Campo requerido']"
              required
            ></v-autocomplete>
            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="mb-2"
              color="red darken-1"
              text
              @click="closeDialogRelator"
            >
              Cerrar
            </v-btn>
            <v-btn
              v-if="editedRelator"
              class="mb-2"
              color="green darken-1"
              text
              @click="editarRelator()"
              :disabled="!validRelator"
              :loading="loading"
            >
              Actualizar RELATOR
            </v-btn>
            <v-btn
              v-else-if="!editedRelator"
              class="mb-2"
              color="green darken-1"
              text
              @click="asignaRelator()"
              :disabled="!validRelator"
              :loading="loading"
            >
              Asignar RELATOR
            </v-btn>
          </v-card-actions>
            </v-form>
          </v-container>
        </v-card>
    </v-dialog>

    <!-- FIN DIALOG ASINAR RELATOR -->

    <v-dialog v-if="dialogAE"
      persistent 
      max-width="1000px"
      v-model="dialogAE" 
    >
    <v-toolbar color="#1D2E4B" dark dense>
      <img src="@/assets/logo_nuevo.png"style="width:40px;height:41px" class="mr-4">
        <v-toolbar-title class="text-uppercase"><b>Previsualización de toca</b>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="#1D2E4B" dark @click.native="closeAE">cerrar</v-btn>
      </v-toolbar>
      
      <v-card>
        <v-container>
          <ApelacionElectronica
            :sala_id="sala_id"
            :hash="hash"
          ></ApelacionElectronica>
        </v-container>
        <!-- <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" dark @click.native="close">cerrar</v-btn>
        </v-card-actions> -->
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>

  import { mapGetters } from "vuex";
  const Swal = require('sweetalert2');
  import ApelacionElectronica from "@/components/ApelacionElectronica";

  export default {
    components: {
      ApelacionElectronica
    },
    data(){
      return {
        loadingOriginal: -1,
        dialogAE: false,
        dialogRelator: false,
        dialog: false,
        valid: false,
        validRelator: false,
        validSearch: false,
        validPreview: false,
        buscar: '',
        buscar_previsualizacion: '',
        sala_id: '',
        ponencia_id: '',
        anio:'',
        numero:'',
        complemento:'',
        num_toca:'',
        ponencia_selected: '',
        relator_selected: '',
        resultSearch: '',
        currentPrevisualizacion: '',
        documento_id: '',
        hash: '',
        loading: false,
        pagination: {
          current: 1,
          total: 0
        },
        currentPage: 1,
        totalPages: 0,
        totalItems: 0,
        itemsPerPage: 20,
        buttons_on_alert: false,
        editedIndex: -1,
        previsualizacion_id: '',
        relator_asignado: false,
        editedRelator: false,
        listPrevisualizaciones:[],
        listTocas:[],
        rules: {
          required:v => !!v || 'Campo requerido',
          requiredSelect:v => !!v|| 'Campo requerido',
          tocaRules:v => /^(\d+)(\/)(\d{4})(\-[A-Z]+)*$/.test(v) || 'Ingrese formato valido',
        },
        listStatus: [
          { status: 1, text: 'Todo' },
          { status: 2, text: 'Pendientes Asignación' },
        ],
        statusToca: 1
      }
    },
    computed: {
      ...mapGetters([
        "currentUser", "roleUser", "getAllPonencias", "listRelatoresPonencia"
      ]),
      formTitle () {
        return this.editedIndex === -1 ? 'Asignar Previsualización' : 'Actualizar Previsualización'
      },
      formTitleRelator () {
        return !this.editedRelator ? 'Asignar Relator' : 'Actualizar Relator'
      },
      headers() {
        if (this.roleUser == 'secacu') {
          return [
            { text: 'TOCA', value: 'toca', sortable: false },
            { text: 'MAGISTRADO', value: 'nombre_magistrado', sortable: false },
            { text: 'FECHA DE CREACIÓN', value: 'created_at', sortable: false },
            { text: 'ACCIONES', value: 'action', sortable: false },
          ]
        }
        else {
          return [
            { text: 'TOCA', value: 'toca', sortable: false },
            { text: 'MAGISTRADO', value: 'nombre_magistrado', sortable: false },
            { text: 'RELATOR', value: 'nombre_relator', sortable: false },
            { text: 'FECHA DE CREACIÓN', value: 'created_at', sortable: false },
            { text: 'ACCIONES', value: 'action', sortable: false },
          ]
        }
      }
    },
    mounted() {
      if (this.roleUser == 'superadmin') {
        // this.loading = false
        // return false;
      } else {
        let user = JSON.parse(localStorage.getItem('user'));
        // this.sala_id = user.sala_id
        this.ponencia_id = user.ponencia_id
      }
      this.getPrevisualizaciones()
      this.$store.dispatch("GET_PONENCIAS", { url: "ponencias" });
      this.$store.dispatch("GET_RELATORES_PONENCIA", { url: "relatores", params: {ponencia_id:this.ponencia_id} });
    },
    watch: {
      buscar_previsualizacion: function (val) {
        if(!val){
          this.getPrevisualizaciones()
        }
      },
    },
    methods:{
      getPrevisualizaciones(){
        if (this.buscar_previsualizacion.length >= 5 && this.$refs.preview.validate()) {
          this.status = {}
          if ( this.buscar_previsualizacion.includes("/") ) var tocacompleto = this.buscar_previsualizacion.replace('/','');
          else var tocacompleto = this.buscar_previsualizacion;
          this.complemento = tocacompleto.split('-').splice(1).join('-');
          var tocacompleto = tocacompleto.split('-')[0];
          this.anio = tocacompleto.substr(tocacompleto.length - 4);
          this.numero = tocacompleto.slice(0, tocacompleto.length - 4);
          if (this.anio && this.numero) {
             this.current = 1
            //  this.getTocas()
          } else {
            this.$swal({
              title: "Error",
              text: "Favor de verificar el formato del toca!!!",
              icon: "error",
              confirmButtonText: "Aceptar"
            });
          }
        }
        this.loading = true
        this.$store.dispatch("GET_PREVISUALIZACIONES",  {url: "/previsualizaciones?page=" + this.pagination.current,
        params: {
          // buscar_previsualizacion:  this.buscar_previsualizacion || undefined,
          // sala_id:  12,
          anio:  this.anio || undefined,
          numero:  this.numero || undefined,
          derivado:  this.complemento || '',
          statusToca: this.statusToca || ''
        }
        }).then(response => {
            this.loading = false
            this.listPrevisualizaciones = response.data.data.previsualizaciones.data;
            this.pagination.current = response.data.data.previsualizaciones.current_page;
            this.pagination.total = response.data.data.previsualizaciones.last_page;
            this.totalItems = response.data.data.previsualizaciones.total;
            this.per_page_table = response.data.data.previsualizaciones.per_page;
            this.anio = ''
            this.numero = ''
            this.complemento = ''
        })
        .catch(error => {
          console.log(error);
        });
      },
      searchToca(){
        if (!this.buscar) return false;
        if (this.buscar.length >= 5 && this.$refs.search.validate()) {
          this.status = {}
          if ( this.buscar.includes("/") ) var tocacompleto = this.buscar.replace('/','');
          else var tocacompleto = this.buscar;
          this.complemento = tocacompleto.split('-').splice(1).join('-');
          var tocacompleto = tocacompleto.split('-')[0];
          this.anio = tocacompleto.substr(tocacompleto.length - 4);
          this.numero = tocacompleto.slice(0, tocacompleto.length - 4);
          if (this.anio && this.numero) {
             this.current = 1
             this.getTocas()
          } else {
            this.$swal({
              title: "Error",
              text: "Favor de verificar el formato del toca!!!",
              icon: "error",
              confirmButtonText: "Aceptar"
            });
          }
        }
      },
      getTocas(){
        this.pageCount = 0
        this.ponencia_selected = ''
        this.loading = true
        this.listTocas = null
        this.$store.dispatch("GET_TOCAS", {
          url: "/previsualizaciones/list-tocas",
          params: {
            page:this.current,
            apelacion_status:  this.status.value || undefined,
            // sala_id:  12,
            anio:  this.anio || undefined,
            numero:  this.numero || undefined,
            derivado:  this.complemento || ''
          }
        }).then(response => {
          this.loading = false
          this.indexLoader = false
          this.buttons_on_alert = true
          this.current = response.data.data.toca.current_page;
          this.pageCount = response.data.data.toca.last_page;
          this.listTocas = response.data.data.toca.data || response.data.data.toca
          this.resultSearch = !this.listTocas.length ? false : true
          this.anio = ''
          this.numero = ''
          this.complemento = ''
          // this.checkButtons()
        });
      },
      showDocument(item){
          this.loadingInline = true;
          this.$store.dispatch("GET_FILE_DOC", {url: "documento/" + item.id + "/previo-multifirma"}).then((response) => {
              const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('target' ,'_blank');
              document.body.appendChild(link);
              link.click()
              this.loadingOriginal = -1;
          })
          .catch(error => {
              this.$swal({
                  title: 'Error al descargar el antecedente, verifique la url.',
                  icon: 'error',
                  confirmButtonText: "Aceptar"
              })
              this.loadingInline = -1;
              console.log(error);
          });
      },
      validate(){
        if (!this.ponencia_selected) {
          this.$swal({
            title: "Debe seleccionar una ponencia",
            icon: "warning",
            confirmButtonText: "Aceptar"
          });
          return false
        } else {
        this.loading = true
        this.$store.dispatch("CREATE_PREVISUALIZACION", { url: "/previsualizacion",
          data:{ 
            ponencia_id: this.ponencia_selected.id,
            magistrado_id: this.ponencia_selected.user_id,
            toca_id: this.listTocas[0].id,
            apelacion_id: this.listTocas[0].apelaciones[0].id,
            sala_id: this.currentUser.sala_id
          } 
        }).then(response => {
          this.loading = false
          // console.log(response)
          this.$swal({
            icon: 'success',
            title: 'Previsualización asignada correctamente.',
            confirmButtonText: "Aceptar"
          })
          this.pagination.current = 1
          this.getPrevisualizaciones();
          this.close();
        }).catch(error => {
            console.log(error);
            this.loading = false;
            this.$swal({
              title: "Error",
              text: error.response.data.message,
              icon: "error",
              confirmButtonText: "Aceptar"
            });
          });
        }
      },
      editar(){
        if (!this.ponencia_selected.id) {
          this.$swal({
            title: "Debe seleccionar otra ponencia para actualizar",
            icon: "warning",
            confirmButtonText: "Aceptar"
          });
        return false
        }
        this.loading = true
        this.$store.dispatch("UPDATE_PREVISUALIZACION", { url: "/previsualizacion/" + this.previsualizacion_id,
          data:{ 
            ponencia_id: this.ponencia_selected.id,
            magistrado_id: this.ponencia_selected.user_id,
          } 
        }).then(response => {
          this.loading = false
          // console.log(response)
          this.$swal({
            icon: 'success',
            title: 'Previsualización actualizada correctamente.',
            confirmButtonText: "Aceptar"
          })
          this.pagination.current = 1
          this.getPrevisualizaciones();
          this.close();
        }).catch(error => {
          console.log(error);
          this.loading = false;
          this.$swal({
            title: "Error",
            text: error.response.data.message,
            icon: "error",
            confirmButtonText: "Aceptar"
          });
        });
      },
      asignaRelator(){
        if (!this.relator_selected) {
          this.$swal({
            title: "Debe seleccionar un relator",
            icon: "warning",
            confirmButtonText: "Aceptar"
          });
          return false
        } else {
        this.loading = true
        this.$store.dispatch("ASIGNA_RELATOR", { url: "/previsualizacion/"+this.currentPrevisualizacion+"/asigna-relator",
          data:{ 
            relator_id: this.relator_selected.id
          } 
        }).then(response => {
          this.loading = false
          // console.log(response)
          this.$swal({
            icon: 'success',
            title: 'Relator asignado correctamente.',
            confirmButtonText: "Aceptar"
          })
          this.getPrevisualizaciones();
          this.closeDialogRelator();
        }).catch(error => {
            console.log(error);
            this.loading = false;
            this.$swal({
              title: "Error",
              text: error.response.data.message,
              icon: "error",
              confirmButtonText: "Aceptar"
            });
          });
        }
      },
      editarRelator(){
        if (!this.relator_selected.id) {
          this.$swal({
            title: "Debe seleccionar otro relator para actualizar",
            icon: "warning",
            confirmButtonText: "Aceptar"
          });
          return false
        } else {
        this.loading = true
        this.$store.dispatch("UPDATE_PREVISUALIZACION", { url: "/previsualizacion/" + this.previsualizacion_id,
          data:{ 
            relator_id: this.relator_selected.id
          } 
        }).then(response => {
          this.loading = false
          // console.log(response)
          this.$swal({
            icon: 'success',
            title: 'Relator actualizado correctamente.',
            confirmButtonText: "Aceptar"
          })
          this.getPrevisualizaciones();
          this.closeDialogRelator();
        }).catch(error => {
            console.log(error);
            this.loading = false;
            this.$swal({
              title: "Error",
              text: error.response.data.message,
              icon: "error",
              confirmButtonText: "Aceptar"
            });
          });
        }
      },
      editItem (item) {
        this.previsualizacion_id = item.id
        this.editedIndex = this.listPrevisualizaciones.indexOf(item)
        this.listTocas.push(item.toca);
        this.listTocas[0].apelaciones = []
        this.listTocas[0].apelaciones.push(item.apelacion);
        this.ponencia_selected = item.ponencia_id
        if (item.relator_id) {
          this.relator_asignado = true
        }
        this.dialog = true
      },
      onPageChange() {
        this.getPrevisualizaciones();
      },
      showApelacionElectronica(item){
        this.hash = item.apelacion.hash;
        this.sala_id = item.apelacion.toca.sala_id
        // this.documento_id = item.id
        this.dialogAE = true
      },
      showDialogRelator(item){
        this.currentPrevisualizacion = item.id
        this.num_toca = item.apelacion.toca.numero+'/'+item.apelacion.toca.anio
        if (item.relator_id) {
          this.ponencia_id = item.ponencia_id
          this.$store.dispatch("GET_RELATORES_PONENCIA", { url: "relatores", params: {ponencia_id:this.ponencia_id} });
          this.relator_selected = item.relator_id
          this.editedRelator = true
          this.previsualizacion_id = item.id
        }
        this.dialogRelator = true
      },
      close () {
        this.dialog = false
        this.showAddBtn = false
        this.$refs.form.resetValidation()
        if (this.editedIndex === -1) {
          this.$refs.search.resetValidation()
        }
        this.resultSearch = ''
        this.numero = ''
        this.anio = ''
        this.buscar = ''
        this.ponencia_selected = ''
        this.listTocas = []
        this.listTocas.value = null
        this.editedIndex = -1
        this.previsualizacion_id = ''
        this.relator_asignado = false
      },
      closeAE () {
        this.dialogAE = false
        // this.getPrevisualizaciones()
      },
      closeDialogRelator () {
        this.dialogRelator = false
        this.relator_selected = ''
        this.ponencia_id = ''
        this.editedRelator = false
        this.previsualizacion_id = ''
        this.$refs.relator.resetValidation()
        // this.getPrevisualizaciones()
      },
    }
  }
</script>

<style>
  @media screen and (max-width: 748px) {
    .btn-spacing {margin: 4px 0;}
  }
  @media screen and (max-width: 540px) {
    .v-toolbar__title {font-size: 1rem!important;}
  }
</style>
  